
import { EnhancedUsersSection } from "./enhanced/EnhancedUsersSection";

export const UsersSection = () => {
  return <EnhancedUsersSection />;
};
